export default __webpack_public_path__ + "static/media/Jami-Masjid.2d44acac.jpg";